module.exports = __webpack_public_path__ + "static/media/Location Sign Green.F10.2k.ee5b81fd.png";